/* Grok 2026-10-10 (Product Pages Batch 4): ignore Vimeo's grey 'default' placeholder thumbnail (videos with no thumbnail set), so the theme poster stays. */
/* FCPeffects product description, E3 layout (templates/product.redesign.json). Grok 2026-10-09 */
(function () {
/* Grok 2026-11-04 (product page v4): on v4 pages the player + picker sit at the top of the page (.fcpe-v4p, snippets/fcpe-v4-player.liquid)
   and this section (.fcpe-h--v4) holds the gallery and the details. P = the element that holds the player; root = the section.
   On every other page there is no .fcpe-v4p, so P === root and everything runs exactly as before. */
var root = document.querySelector('.fcpe-h:not(.fcpe-v4p)') || document.querySelector('.fcpe-v4p'); if (!root) return;
var P = document.querySelector('.fcpe-v4p') || root;
function qa(sel) { var a = Array.prototype.slice.call(root.querySelectorAll(sel)); if (P !== root) a = a.concat(Array.prototype.slice.call(P.querySelectorAll(sel))); return a; }
var mq = window.matchMedia('(min-width: 1024px)');
function sync() {
root.querySelectorAll('details[data-desk-open]').forEach(function (d) {
if (d.dataset.touched) return;
d.open = mq.matches || d.hasAttribute('data-keep-open');
});
}
sync(); mq.addEventListener('change', sync);
root.querySelectorAll('details > summary').forEach(function (s) { s.addEventListener('click', function () { s.parentNode.dataset.touched = '1'; }); });
/* Vimeo oEmbed: video durations and picker thumbnails */
var seen = {};
qa('[data-vdur],[data-vimeo]').forEach(function (el) {
var id = el.getAttribute('data-vdur') || el.getAttribute('data-vimeo'); if (!id || seen[id]) return; seen[id] = 1;
fetch('https://vimeo.com/api/oembed.json?url=https://vimeo.com/' + id + '&width=640').then(function (r) { return r.json(); }).then(function (j) {
var m = Math.floor(j.duration / 60), s = ('0' + (j.duration % 60)).slice(-2);
qa('[data-vdur="' + id + '"]').forEach(function (e) { e.textContent = '(' + m + ':' + s + ')'; });
if (j.thumbnail_url && j.thumbnail_url.indexOf('/video/default-') < 0) qa('[data-vimeo="' + id + '"] .fcpe-h__pimg').forEach(function (e) { e.style.backgroundImage = 'url(' + j.thumbnail_url + ')'; });
}).catch(function () {});
});
var gv = root.querySelectorAll('.fcpe-h__gal video');
gv.forEach(function (v) { v.muted = true; v.playsInline = true; });
if (gv.length && 'IntersectionObserver' in window) { var vio = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); } }); }, { threshold: 0.25 }); gv.forEach(function (v) { vio.observe(v); }); }
var main = P.querySelector('.fcpe-h__main');
/* poster first: Vimeo thumbnail behind the iframe; the iframe fades in once the demo loop is playing (CSS fallback after 3s) */
var vbox = main && main.parentElement;
if (vbox && vbox.dataset.poster) {
fetch('https://vimeo.com/api/oembed.json?url=https://vimeo.com/' + vbox.dataset.poster + '&width=1280').then(function (r) { return r.json(); }).then(function (j) { if (j.thumbnail_url && j.thumbnail_url.indexOf('/video/default-') < 0) vbox.style.backgroundImage = 'url(' + j.thumbnail_url + ')'; }).catch(function () {});
window.addEventListener('message', function (e) {
if (!main.contentWindow || e.source !== main.contentWindow) return;
var d = e.data; if (typeof d === 'string') { try { d = JSON.parse(d); } catch (x) { return; } }
if (!d || !d.event) return;
if (d.event === 'ready') { ['play', 'playProgress'].forEach(function (ev) { try { main.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: ev }), '*'); } catch (x) {} }); }
if (d.event === 'play' || d.event === 'playProgress') vbox.classList.add('is-playing');
});
}
function play(src, auto) { if (!main || !src) return; src = src.trim(); if (vbox && src.indexOf('background=1') < 0) vbox.classList.add('is-playing'); var u = src + (auto && src.indexOf('background=1') < 0 ? (src.indexOf('?') < 0 ? '?' : '&') + 'autoplay=1' : ''); if (main.getAttribute('src') !== u) main.setAttribute('src', u); }
/* Grok 2026-11-04 (native tutorial): a pick with data-native plays the Shopify-hosted <video> in the player box. */
var nat = P.querySelector('.fcpe-h__nat');
/* Grok 2026-11-04 (muted start): the tutorial starts muted (muted + playsinline, so iOS autoplays it) with a Vimeo-style
   'Unmute' pill at the top centre. The pill, or unmuting with the native controls, unmutes and hides the pill.
   Switching picks away and back keeps the visitor's mute choice. */
var unm = P.querySelector('.fcpe-h__unm');
function natSync() { if (nat && vbox) vbox.classList.toggle('is-nmuted', nat.muted || nat.volume === 0); }
if (nat) { nat.muted = true; nat.defaultMuted = true; nat.addEventListener('volumechange', natSync); }
if (unm && nat) unm.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); nat.muted = false; if (nat.volume === 0) nat.volume = 1; natSync(); if (nat.paused) { var q = nat.play(); if (q && q.catch) q.catch(function () {}); } });
/* Tutorial-first products: the <video> autoplays muted from the markup; nudge play() in case the attribute alone didn't start it. */
if (nat && vbox && vbox.classList.contains('is-native')) { natSync(); var p0 = nat.play(); if (p0 && p0.catch) p0.catch(function () {}); }
function natOn() { if (!nat || !vbox) return; try { main.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*'); } catch (e) {} vbox.classList.add('is-native', 'is-playing'); natSync(); var pr = nat.play(); if (pr && pr.catch) pr.catch(function () {}); }
function natOff() { if (!nat || !vbox) return; nat.pause(); vbox.classList.remove('is-native'); }
var picks = P.querySelectorAll('.fcpe-h__pick');
picks.forEach(function (p) {
function go() { picks.forEach(function (x) { x.classList.remove('is-active'); }); p.classList.add('is-active'); if (p.dataset.native) { natOn(); } else { natOff(); play(p.dataset.src, true); } }
p.addEventListener('click', go); p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
});
var how = root.querySelector('details[data-play]');
/* Opening "How to use" switches the main player to the tutorial. Compare trimmed URLs: the description's
   embed URLs used to carry newlines, which made the old attribute selector invalid (it threw, so nothing switched). */
if (how) how.addEventListener('toggle', function () {
/* Grok 2026-10-16 (extended-first preview): only a visitor's own click on the summary (sets data-touched above) may switch the player.
   balance() and sync() open/close this <details> from script on desktop, which fires 'toggle' too and used to force the Tutorial on load. */
if (!how.open || !how.dataset.play || !how.dataset.touched) return;
var want = how.dataset.play.trim();
for (var i = 0; i < picks.length; i++) { if ((picks[i].dataset.src || '').trim() === want) { if (!picks[i].classList.contains('is-active')) picks[i].click(); return; } }
play(want, true);
});
/* balance the two columns: move sections under the player and pick the gallery layout so both columns end together */
var R = root.querySelector('.fcpe-h__wrap--v > .fcpe-h__accs:not(.fcpe-h__left)');
var Lc = root.querySelector('.fcpe-h__wrap--v > .fcpe-h__left');
if (R && Lc) {   /* v4 (2026-11-04): no two-column wrap in this section, so nothing to balance */
var movable = Array.prototype.slice.call(R.querySelectorAll(':scope > details[data-sec]'));
function leftBottom() { var w = root.querySelector('.fcpe-h__wrap--v'); var m = 0; ['.fcpe-h__player', '.fcpe-h__buy', '.fcpe-h__gal', '.fcpe-h__left'].forEach(function (q) { var e = w.querySelector(':scope > ' + q); if (e && e.offsetParent !== null) { var bb = e.getBoundingClientRect().bottom; if (bb > m) m = bb; } }); return m; }
var G = root.querySelector('.fcpe-h__gal'), HOW = root.querySelector('details[data-how]');
var gn = G ? +G.getAttribute('data-n') : 0;
var full = gn > 0 && gn % 3 === 0; // 3 or 6 items: always whole rows of 3 on desktop
var modes = !G ? [null] : (full ? [{ gc: 3, w: false }] : (gn >= 4 ? [{ gc: 2, w: true }, { gc: 3, w: false }, { gc: 2, w: false }] : [{ gc: 2, w: true }, { gc: 3, w: false }]));
var mobMode = !G ? null : (full && gn === 6 ? { gc: 2, w: false } : { gc: 2, w: true });
var WR = root.querySelector('.fcpe-h__wrap--v');
var spc = ['.fcpe-h__buy', '.fcpe-h__gal', '.fcpe-h__left'].map(function (q) { return WR.querySelector(':scope > ' + q); }).filter(function (e) { return e; });
function setMode(m) { if (!G || !m) return; G.style.setProperty('--gc', m.gc); G.classList.toggle('has-wide', m.w); }
function moveLoop() {
movable.forEach(function (d) { R.appendChild(d); });
for (var i = movable.length - 1; i >= 0; i--) {
var diff = R.getBoundingClientRect().bottom - leftBottom();
var h = movable[i].getBoundingClientRect().height;
if (diff <= 0 || Math.abs(diff - 2 * h) >= Math.abs(diff)) break;
Lc.insertBefore(movable[i], Lc.firstChild);
}
return R.getBoundingClientRect().bottom - leftBottom();
}
function balance() {
movable.forEach(function (d) { R.appendChild(d); });
spc.forEach(function (e) { e.style.marginTop = ''; });
if (!mq.matches) { setMode(mobMode); if (HOW && !HOW.dataset.touched) HOW.open = false; return; }
var hows = (HOW && !HOW.dataset.touched) ? [true, false] : [null], best = null;
modes.forEach(function (m) { hows.forEach(function (ho) {
setMode(m); if (ho !== null) HOW.open = ho;
var d = moveLoop(); if (!best || Math.abs(d) < Math.abs(best.d) - 4) best = { m: m, ho: ho, d: d };
}); });
setMode(best.m); if (best.ho !== null) HOW.open = best.ho; best.d = moveLoop();
/* feedback1: share any leftover difference across the left column's section spacing so both columns end together */
var vis = spc.filter(function (e) { return e.offsetParent !== null && (e !== Lc || Lc.children.length); });
if (Math.abs(best.d) > 6 && vis.length) { var adj = Math.max(-36, Math.min(60, best.d)) / vis.length; vis.forEach(function (e) { e.style.marginTop = Math.max(6, parseFloat(getComputedStyle(e).marginTop) + adj) + 'px'; }); best.d = R.getBoundingClientRect().bottom - leftBottom(); }
root.setAttribute('data-balanced', Lc.children.length);
root.setAttribute('data-gap', Math.round(best.d));
}
var bt; window.addEventListener('resize', function () { clearTimeout(bt); bt = setTimeout(balance, 150); });
balance(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(balance);
}

/* 2026-10-09 gallery pop-out (Turner): stills and clips open larger over the page instead of a new tab.
   Sized to the featured video's width on desktop, nearly full width on phones/tablets; prev/next, keys, swipe, Esc. */
(function () {
/* v4 2026-11-04 (mockup 2): on v4 pages the items are the moves in the 'See it move' viewer (.fcpe-mv__it, media kept in a <template>) */
var GAL = root.querySelector('[data-fcpe-mv]') || root.querySelector('.fcpe-h__gal'); if (!GAL) return;
var items = Array.prototype.slice.call(GAL.querySelectorAll('.fcpe-mv__it, .fcpe-h__gi'));
if (!items.length) return;
var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
var ICON = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; };
var wrap = document.createElement('div');
wrap.className = 'fcpe-lb'; wrap.hidden = true;
wrap.innerHTML = '<div class="fcpe-lb__bg" data-lb-close></div>' +
  '<div class="fcpe-lb__dlg" role="dialog" aria-modal="true" aria-label="Gallery" tabindex="-1">' +
  '<button type="button" class="fcpe-lb__btn fcpe-lb__close" data-lb-close aria-label="Close">' + ICON('<path d="M6 6l12 12M18 6L6 18"/>') + '</button>' +
  '<div class="fcpe-lb__media"><div class="fcpe-lb__slot"></div>' +
  '<button type="button" class="fcpe-lb__btn fcpe-lb__prev" aria-label="Previous">' + ICON('<path d="M15 5l-7 7 7 7"/>') + '</button>' +
  '<button type="button" class="fcpe-lb__btn fcpe-lb__next" aria-label="Next">' + ICON('<path d="M9 5l7 7-7 7"/>') + '</button></div>' +
  '<div class="fcpe-lb__foot"><p class="fcpe-lb__cap"></p><span class="fcpe-lb__n" aria-live="polite"></span></div></div>';
document.body.appendChild(wrap);
var dlg = wrap.querySelector('.fcpe-lb__dlg'), slot = wrap.querySelector('.fcpe-lb__slot'), cap = wrap.querySelector('.fcpe-lb__cap'), num = wrap.querySelector('.fcpe-lb__n');
var prevB = wrap.querySelector('.fcpe-lb__prev'), nextB = wrap.querySelector('.fcpe-lb__next');
if (items.length < 2) { prevB.hidden = true; nextB.hidden = true; num.hidden = true; }
var cur = -1, opener = null, paused = [], closing = false;
function size() {
  var vw = window.innerWidth, vh = window.innerHeight, w;
  var fv = P.querySelector('.fcpe-h__player .fcpe-h__vid');
  if (vw >= 1024 && fv && fv.offsetWidth) { w = Math.min(fv.getBoundingClientRect().width, vw - 80); } else { w = vw - (vw >= 600 ? 48 : 24); }
  var maxH = vh - (vw >= 1024 ? 150 : 130); /* room for the close button and the caption */
  if (w * 9 / 16 > maxH) w = maxH * 16 / 9;
  dlg.style.width = Math.round(Math.max(240, w)) + 'px';
}
function show(i) {
  cur = (i + items.length) % items.length;
  var fig = items[cur], tp = fig.querySelector('template'), sc = tp ? tp.content : fig;
  var a = sc.querySelector('a[data-fcpe-lb]'), v = sc.querySelector('video'), fc = fig.querySelector('figcaption');
  var capTxt = fig.getAttribute('data-cap') || (fc ? fc.textContent : '');
  slot.innerHTML = '';
  if (a) {
    var im = document.createElement('img'); var t = a.querySelector('img');
    im.alt = t ? t.alt : ''; im.decoding = 'async';
    var href = new URL(a.getAttribute('href'), location.href).href;
    if (t && (t.currentSrc || t.getAttribute('src'))) im.src = t.currentSrc || new URL(t.getAttribute('src'), location.href).href; /* instant preview, then full resolution */
    var full = new Image(); full.onload = function () { if (slot.contains(im)) im.src = href; }; full.src = href;
    slot.appendChild(im);
  } else if (v) {
    var c = document.importNode(v, true); c.removeAttribute('id'); c.muted = true; c.defaultMuted = true; c.loop = true; c.playsInline = true; c.autoplay = !RM.matches; c.controls = RM.matches; /* reduced motion: no autoplay, the visitor starts it */
    c.setAttribute('muted', ''); c.setAttribute('playsinline', ''); c.setAttribute('preload', 'auto');
    slot.appendChild(c); if (!RM.matches) { var p = c.play(); if (p && p.catch) p.catch(function () {}); }
  }
  cap.textContent = capTxt;
  cap.hidden = !capTxt;
  num.textContent = (cur + 1) + ' / ' + items.length;
}
function pauseAll() {
  paused = [];
  if (nat && !nat.paused) nat.pause();
  root.querySelectorAll('.fcpe-h__gal video, .fcpe-mv__media video').forEach(function (v) { if (!v.paused) { paused.push(v); v.pause(); } });
  var m = P.querySelector('.fcpe-h__main');
  if (m && m.contentWindow) { try { m.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*'); } catch (e) {} }
}
function open(i, from) {
  if (!wrap.hidden) { show(i); return; }
  opener = from || document.activeElement; closing = false;
  pauseAll();
  var sbw = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.classList.add('fcpe-lb-lock');
  if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
  size(); show(i); wrap.hidden = false;
  var src = (from && from.closest && (from.closest('.fcpe-v4__st') || from.closest('.fcpe-mv__stage'))) || items[cur].querySelector('.fcpe-h__gm');   /* v4: grow from the still under the player */
  if (!RM.matches && src) {
    var r = src.getBoundingClientRect(), d = dlg.getBoundingClientRect();
    var sx = r.width / d.width, sy = r.height / d.height;
    dlg.style.transition = 'none';
    dlg.style.transform = 'translate(' + (r.left - d.left) + 'px,' + (r.top - d.top) + 'px) scale(' + sx + ',' + sy + ')';
    dlg.offsetWidth; /* commit the start state */
    dlg.style.transition = ''; dlg.style.transform = '';
  }
  requestAnimationFrame(function () { wrap.classList.add('is-open'); dlg.focus({ preventScroll: true }); });
}
function close() {
  if (wrap.hidden || closing) return; closing = true;
  wrap.classList.remove('is-open');
  var done = function () {
    wrap.hidden = true; slot.innerHTML = ''; closing = false;
    document.documentElement.classList.remove('fcpe-lb-lock'); document.body.style.paddingRight = '';
    paused.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }); paused = [];
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  };
  if (RM.matches) done(); else setTimeout(done, 260);
}
items.forEach(function (fig, i) {
  var gm = fig.querySelector('.fcpe-h__gm'); if (!gm) return;
  gm.addEventListener('click', function (e) { e.preventDefault(); open(i, fig.querySelector('a[data-fcpe-lb]') || gm); });
  gm.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === gm) { e.preventDefault(); open(i, gm); } });
});
wrap.addEventListener('click', function (e) { if (e.target.closest('[data-lb-close]')) close(); });
prevB.addEventListener('click', function () { show(cur - 1); });
nextB.addEventListener('click', function () { show(cur + 1); });
document.addEventListener('keydown', function (e) {
  if (wrap.hidden) return;
  if (e.key === 'Escape') { e.preventDefault(); close(); }
  else if (e.key === 'ArrowLeft' && items.length > 1) { e.preventDefault(); show(cur - 1); }
  else if (e.key === 'ArrowRight' && items.length > 1) { e.preventDefault(); show(cur + 1); }
  else if (e.key === 'Tab') { /* keep focus inside the pop-out */
    var f = Array.prototype.slice.call(dlg.querySelectorAll('button')).filter(function (b) { return !b.hidden; });
    if (!f.length) return; var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === dlg)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
});
var tx = null, ty = null;
dlg.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; } }, { passive: true });
dlg.addEventListener('touchend', function (e) {
  if (tx === null || items.length < 2) return; var t = e.changedTouches[0], dx = t.clientX - tx, dy = t.clientY - ty; tx = null;
  if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(cur + (dx < 0 ? 1 : -1));
}, { passive: true });
var rt; window.addEventListener('resize', function () { if (wrap.hidden) return; clearTimeout(rt); rt = setTimeout(size, 100); });
window.fcpeLightbox = { open: open, close: close, show: show };
/* v4 (2026-11-04): the 4 stills under the top player open the same pop-out */
if (P !== root) P.querySelectorAll('.fcpe-v4__st[data-i]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(+b.getAttribute('data-i'), b); }); });
})();
/* v4 2026-11-04 (Turner picked mockup 2): the 'See it move' viewer next to What it does (markup: sections/fcpe-desc-hybrid.liquid).
   One big stage + a list of moves. Picking a move swaps the stage; only the stage ever plays a clip, so one clip plays at a time.
   Clips are muted, play only while the stage is at least half on screen and the tab is visible, pause while the pop-out is open,
   and never start by themselves when the visitor asks for reduced motion (the Play button starts them).
   The big picture / clip (or the corner button) opens the pop-out at that move. */
(function () {
var V = root.querySelector('[data-fcpe-mv]'); if (!V) return;
var its = Array.prototype.slice.call(V.querySelectorAll('.fcpe-mv__it'));
var stage = V.querySelector('.fcpe-mv__stage'), media = V.querySelector('.fcpe-mv__media'), capEl = V.querySelector('.fcpe-mv__cap');
var pp = V.querySelector('.fcpe-mv__pp'), zoom = V.querySelector('.fcpe-mv__zoom');
var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
var DE = document.documentElement;
var cur = 0, vid = null, inView = false, userWants = null;
function setPP() {
  if (!vid) { pp.hidden = true; return; }
  pp.hidden = false; var on = !vid.paused;
  pp.classList.toggle('is-paused', !on);
  pp.setAttribute('aria-label', on ? 'Pause clip' : 'Play clip');
}
function shouldPlay() {
  if (!vid || !inView || document.hidden || DE.classList.contains('fcpe-lb-lock')) return false;
  return userWants === null ? !RM.matches : userWants;
}
function sync() {
  if (!vid) { setPP(); return; }
  if (shouldPlay()) { if (vid.paused) { vid.preload = 'auto'; var p = vid.play(); if (p && p.catch) p.catch(function () { setPP(); }); } }
  else if (!vid.paused) vid.pause();
  setPP();
}
function prep(v) {
  if (!v) return null;
  v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; v.autoplay = false; v.controls = false;
  v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.removeAttribute('autoplay');
  v.addEventListener('play', setPP); v.addEventListener('pause', setPP);
  return v;
}
function pick(i) {
  if (i === cur) return;
  var it = its[i], tp = it && it.querySelector('template'); if (!tp) return;
  if (vid) { vid.pause(); vid.removeAttribute('src'); Array.prototype.forEach.call(vid.querySelectorAll('source'), function (s) { s.removeAttribute('src'); }); try { vid.load(); } catch (e) {} }
  media.innerHTML = ''; media.appendChild(document.importNode(tp.content, true));
  var img = media.querySelector('img'); if (img) img.loading = 'eager';
  vid = prep(media.querySelector('video'));
  cur = i; userWants = null;
  stage.setAttribute('data-kind', it.getAttribute('data-kind') || '');
  capEl.textContent = it.getAttribute('data-cap') || '';
  its.forEach(function (x, j) { x.classList.toggle('is-on', j === i); var b = x.querySelector('.fcpe-mv__btn'); if (b) b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
  sync();
}
vid = prep(media.querySelector('video'));
its.forEach(function (it, i) { var b = it.querySelector('.fcpe-mv__btn'); if (b) b.addEventListener('click', function () { pick(i); }); });
function big(e) { if (e) { e.preventDefault(); e.stopPropagation(); } if (window.fcpeLightbox) window.fcpeLightbox.open(cur, stage); }
media.addEventListener('click', big);
if (zoom) zoom.addEventListener('click', big);
pp.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (!vid) return; userWants = vid.paused; sync(); });
if ('IntersectionObserver' in window) {
  new IntersectionObserver(function (es) { es.forEach(function (e) { inView = e.isIntersecting && e.intersectionRatio >= 0.5; }); sync(); }, { threshold: [0, 0.5, 1] }).observe(stage);
} else { inView = true; }
document.addEventListener('visibilitychange', sync);
if (RM.addEventListener) RM.addEventListener('change', sync);
/* the pop-out resumes what it paused when it closes; re-check so an off-screen or reduced-motion clip stays paused */
new MutationObserver(function () { setTimeout(sync, 0); }).observe(DE, { attributes: true, attributeFilter: ['class'] });
/* stick only when the whole card fits under the header (96px) in the window */
var IN = V.querySelector('.fcpe-mv__in');
function fit() { V.classList.toggle('is-tall', IN.offsetHeight + 112 > window.innerHeight); }
var ft; window.addEventListener('resize', function () { clearTimeout(ft); ft = setTimeout(fit, 120); });
fit(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
setPP(); sync();
})();
})();
